const normalize = (value) => String(value || "").trim().toUpperCase();

export function economicMechanism(position) {
  const explicit = normalize(position?.economicMechanism ?? position?.economic_mechanism);
  if (explicit) return explicit;

  const categories = (position?.treatment_mechanisms || [])
    .map((mechanism) => normalize(mechanism?.category))
    .filter(Boolean);
  if (categories.length === 1) {
    if (categories[0] === "RETAIN") return "RETENTION";
    if (categories[0] === "MITIGATE") return "MITIGATION";
  }

  const decisionType = normalize(position?.decision_type);
  if (decisionType === "RETAIN") return "RETENTION";
  if (decisionType === "MITIGATE") return "MITIGATION";
  return explicit || "UNKNOWN";
}

export function evaluatedMechanism(data) {
  const maximum = data?.capitalEfficiencyFrontier?.maximumModeledProtection;
  const maximumMechanism = economicMechanism(maximum);
  if (maximumMechanism !== "UNKNOWN" && maximumMechanism !== "BASELINE") return maximumMechanism;

  const mechanisms = new Set((data?.selected_actions || [])
    .filter((action) => !action.is_baseline)
    .map(economicMechanism)
    .filter((mechanism) => mechanism !== "UNKNOWN" && mechanism !== "BASELINE"));
  return mechanisms.size === 1 ? [...mechanisms][0] : mechanisms.size > 1 ? "COMBINED" : "UNKNOWN";
}
